import { EColors, EFont } from "common/styles";
import { FONT } from "common/utils";
import styled from "styled-components";
import { StyledInputProps } from "./types";
import { Field } from "formik";

export const Label = styled.label`
  position: absolute;
  transform: translateY(2rem);
  top: -15px;
  left: 16px;
  transform-origin: left top;
  font-family: ${EFont.Fira_Sans};
  font-weight: 600;
    font-size: 16px;
    line-height: 20.16px;
    color: ${EColors.neutral_500};
  cursor: text;
  transition: all 0.3s;
  pointer-events: none;
  border: 1px solid transparent;
`;

export const StyledInput = styled(Field)<StyledInputProps>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  background: ${EColors.neutral_600};
  border:${({ isInvalid }) => isInvalid ? '1px solid #E04E4E' : '1px solid transparent'};
  border-radius:8px;
  padding: 10px 16px;
  outline: none;
  display: flex;
  align-items: flex-start;
  ${FONT({ color: EColors.white, weight: "400", size: "18px" })}
  transition:all 0.3s linear;
  &::placeholder {
    color: transparent;
  }
  &:hover{
    background:#424242
  }
  &:focus, &:active {
     border: 1px solid ${EColors.accent_300};
  }
 
  &:focus,
  &:not(:placeholder-shown) {
    padding-top: 1.625rem;
    padding-bottom: 0.625rem;
    outline: none;
  }
  &:focus + ${Label}, &:not(:placeholder-shown) + ${Label} {
    ${FONT({ color: EColors.white, weight: "400", size: "14px" })}
    padding: 0;
    cursor: text;
    transform: translateY(18px);
  }
`;

export const StyledInputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const Error = styled.span`
  position: absolute;
  top: 105%;
  left:16px;
  width: 100%;
  height: 5px;
  ${FONT({
    size: "14px",
    weight: "400",
    color: `${EColors.red}`,
  })}
`;


export const StyledTextareaWrapper = styled.div`
position:relative;
width: 100%;
`
export const LabelTextarea = styled(Label)`
  position: absolute;
  transform: translateY(2rem);
  top: -18px;
  left: 16px;
`;
export const StyledTextarea = styled(Field)`
width:100%;
height:93px;
  padding: 10px 16px;
   background: ${EColors.neutral_600};
  border: 1px solid transparent;
  border-radius:8px;
  outline: none;
  display: flex;
  align-items: flex-start;
  ${FONT({ color: EColors.white, weight: "400", size: "18px" })}
  transition:all 0.3s linear;
  resize: none;
 &:hover{
    background:#424242
  }
  &:focus, &:active {
     border: 1px solid ${EColors.accent_300};
  }
 
  &:focus,
  &:not(:placeholder-shown) {
    padding-top: 1.625rem;
    padding-bottom: 0.625rem;
    outline: none;
  }
  &:focus + ${LabelTextarea}, &:not(:placeholder-shown) + ${LabelTextarea} {
    ${FONT({ color: EColors.white, weight: "400", size: "14px" })}
    padding: 0;
    cursor: text;
    transform: translateY(18px);
  }
  @media screen and (min-width: 1000px){
    height:177px;
}
`